// *********** Vision Validations ***********
// https://stash1-tools.swacorp.com/projects/UI/repos/swa-form/browse/src/validators/validation-settings.js
// *********** Leap Frog Validations ***********
// eslint-disable-next-line max-len
// https://stash1-tools.swacorp.com/projects/COM/repos/commerce-project/browse/web/src/main/java/com/swacorp/dotcom/loyalty/validator/FieldValidator.java#37,208
const alpha = "a-zA-Z";
const hashtag = String.raw `\#`;
const hyphen = String.raw `\-`;
const numeric = String.raw `\d`;
const period = String.raw `\.`;
const punct = "!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~";
const space = " ";
const whiteSpace = String.raw `\s`;
export const regexes = {
    alpha: allowedPattern(alpha),
    alphaHashtagHyphenPeriodSpace: allowedPattern(`${alpha}${hashtag}${hyphen}${period}${space}`),
    alphaHyphenPeriodSpace: allowedPattern(`${alpha}${hyphen}${period}${space}`),
    alphaNumeric: allowedPattern(`${alpha}${numeric}`),
    alphaNumericHashtagHyphenPeriodSpace: allowedPattern(`${alpha}${numeric}${hashtag}${hyphen}${period}${space}`),
    alphaNumericHyphenPeriodSpace: allowedPattern(`${alpha}${numeric}${hyphen}${period}${space}`),
    alphaNumericPunct: allowedPattern(`${alpha}${numeric}${punct}`),
    alphaNumericPunctSpace: allowedPattern(`${alpha}${numeric}${punct}${space}`),
    alphaNumericPunctWhiteSpace: allowedPattern(`${alpha}${numeric}${punct}${whiteSpace}`),
    alphaNumericSpace: allowedPattern(`${alpha}${numeric}${space}`),
    alphaSpace: allowedPattern(`${alpha}${space}`),
    noBackslash: /^[^\\]+$/,
    noDoubleQuotes: /^[^"]+$/,
    numeric: allowedPattern(numeric),
    phone: /^\(?\d{3}\)?[- ]?\d{3}[- ]?\d{4}$/,
    positive: /^[1-9]/,
    validDate: /^(0\d|1[0-2])\/(0[1-9]|1\d|2\d|3[0-1])\/\d{4}$/,
    // eslint-disable-next-line max-len
    validEmail: /^(([^<>()[\]\\.,;:\s@"|]+(\.[^<>()[\]\\.,;:\s@"|]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, // NOSONAR
};
function allowedPattern(allowed) {
    return new RegExp(`^[${allowed}]*$`);
}
